import {GvfService} from "../../../gvf/js/gvf-service";
import {FormField} from "../form-field/form-field";

export class FormFieldChecks extends FormField{
    constructor(scope,$root){
        super(scope,$root);
        this.$checks = null;
        this.$search = null;
    }

    getVal(){
        const values = [];
        this.$checks.filter(":checked").each(
            (index,item)=>{
                values.push($(item).val());
            }
        );
        return values;
    }

    setVal(val,noEvent){
        //todo set val
    }

    ready(){
        super.ready();
        this.$checks = this.findMember("check");
        this.$search = this.findMember("search");
        this.$checks.click(
            ()=>{
                this.$root.trigger("formField:changeVal");
            }
        );

        this.$search.keyup(
            ()=>{
                if(this.$search.val()==""){
                    this.$root.find(this.scope+"__check-container").show();
                }else{
                    GvfService.delay(500,"checksearch").then(
                        ()=>{
                            const s = this.$search.val().toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"");
                            this.findMember("check-container").each(
                                (index,item)=>{
                                    const t = $(item).text().toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"");
                                    $(item).toggle(t.indexOf(s)>-1);
                                }
                            );
                        }
                    );
                }
            }
        );
    }
}
